import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import TrustBar from './components/TrustBar';
import FeatureCards from './components/FeatureCards';
import CategorySection from './components/CategorySection';
import ComparisonSection from './components/ComparisonSection';
import HowItWorks from './components/HowItWorks';
import ArticleCardsSection from './components/ArticleCardsSection';
import SafetyFAQSection from './components/SafetyFAQSection';
import SeoSchema from '@/components/base/SeoSchema';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <SeoSchema type="home" />
      <Navbar />
      <main>
        <HeroSection />
        <TrustBar />
        <FeatureCards />
        <CategorySection />
        <ComparisonSection />
        <HowItWorks />
        <ArticleCardsSection />
        <SafetyFAQSection />
      </main>
      <Footer />
    </div>
  );
}